import React, { useState } from "react";
import "./topmeteo.css";
import { StartIcon } from "../icon/icon.jsx";
import { QuestionCircleOutlined, RiseOutlined } from "@ant-design/icons";
import { colors } from "~/theme/colors.js";
import { Modal } from "antd";
import { $t } from "~/i18n.js";
import { convertTopMeteo } from "./topmeteoconverter.js";

const high = [100, 300, 1000];
const midlevel = [600, 1200, 1800];

const CloudSquare = ({ value, max = 3000, label, color_range = [] }) => {
  // if below first value white, if above last value dark gray, in between use color_lookup to find the right color
  var bg;
  if (value === null || value < color_range[0]) {
    bg = "white";
  } else if (value < color_range[1]) {
    bg = "rgb(211, 211, 211)"; // thin
  } else if (value < color_range[2]) {
    bg = "rgb(169, 169, 169)"; // middle
  } else {
    bg = "rgb(105, 105, 105)"; // heavy
  }

  const textColor = value != null && value > max / 2 ? "#ffffff" : "#000000";
  return (
    <div
      className="topmeteo-square"
      style={{ backgroundColor: bg, color: textColor }}
    >
      {label && <span>{label}</span>}
    </div>
  );
};

export const Topmeteo = ({ topmeteoData, unit }) => {
  if (!topmeteoData) return null;

  const [modalOpen, setModalOpen] = useState(false);

  const data = convertTopMeteo(topmeteoData, unit);

  return (
    <div className="topmeteo">
      <div className="row" style={{ gap: 6, justifyContent: "space-between" }}>
        <div>
          <CloudSquare value={data.clouds_high} label="H" color_range={high} />
          <CloudSquare
            value={data.clouds_midlevel}
            label="M"
            color_range={midlevel}
          />
        </div>
        <div className="row" style={{ gap: 6 }}>
          <div className="icon icon-ww136" style={{ color: colors.topmeteo }} />
          <span>{data.cumulus} / 8</span>
        </div>
      </div>

      <div className="row" style={{ gap: 6, justifyContent: "space-between" }}>
        <div className="row" style={{ gap: 6 }}>
          <RiseOutlined style={{ color: colors.topmeteo }} />
          <span>
            {data.thermal} {data.thermal_unit}
          </span>
        </div>

        <div className="row" style={{ gap: 6 }}>
          <StartIcon style={{ color: colors.topmeteo }} />
          <span>
            {data.pfd} {data.pfd_unit}
          </span>
        </div>
      </div>

      <div className="row" style={{ gap: 6, justifyContent: "space-between" }}>
        <div className="row" style={{ gap: 6 }}>
          <span
            style={{
              display: "inline-block",
              transform: `rotate(${data.wind_10_ang - 180}deg)`,
              lineHeight: 1,
              color: colors.topmeteo,
            }}
          >
            ↑
          </span>
          <span>
            {data.wind_10_mag} {data.wind_10_mag_unit}
          </span>
        </div>

        <div className="row" style={{ gap: 6 }}>
          {data.weather !== 0 && (
            <span
              className={`icon icon-ww${data.weather}`}
              style={{ fontSize: 12, paddingRight: 4, color: colors.topmeteo }}
            />
          )}
          <span>
            {data.temp_2m} {data.temp_2m_unit}
          </span>
        </div>
      </div>

      <div
        className="clickable topmeteo-attribution"
        onClick={() => setModalOpen(true)}
      >
        <img src="/topmeteo.png" alt="Powered by TopMeteo" />
        <QuestionCircleOutlined
          style={{ fontSize: 18, color: colors.topmeteo }}
        />
      </div>

      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        title={$t("Weer aangeleverd door TopMeteo")}
      >
        <p>
          {$t(
            "Deze data is mogelijk gemaakt door TopMeteo. Het bevat gemiddelden tussen 10.00 en 14.00 UTC (12 tot 1600 CEST)",
          )}
        </p>

        <table className="topmeteo-legend">
          <tbody>
            <tr>
              <td>H / M</td>
              <td>{$t('Hoge en middelhoge wolken')}</td>
            </tr>
            <tr>
              <td><span className="icon icon-ww136" /></td>
              <td>{$t('Thermische cumulusbewolking (octa\'s)')}</td>
            </tr>
            <tr>
              <td><RiseOutlined /></td>
              <td>{$t('Gemiddelde thermieksterkte')}</td>
            </tr>
            <tr>
              <td>↑</td>
              <td>{$t('Windrichting en -snelheid')}</td>
            </tr>
            <tr>
              <td><span className={`icon icon-ww${data.weather}`} style={{ color: colors.topmeteo }}/></td>
              <td>{$t('Weerfenomeen en temperatuur')}</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 16 }}>
          {$t("Meer informatie vind je op ")}
          <a
            href="https://topmeteo.eu/en/?utm_source=glidingapp&utm_medium=wx_widget&utm_campaign=logo"
            target="_blank"
          >
            {$t("de website van TopMeteo")}
          </a>
          .
        </p>

        <div className="topmeteo-attribution">
          <img src="/topmeteo.png" alt="Powered by TopMeteo" />
        </div>
      </Modal>
    </div>
  );
};
